import { ListBulletIcon, PlusCircleIcon } from "@heroicons/react/24/solid";
import { zodResolver } from "@hookform/resolvers/zod";
import { Checkbox, Spinner, Typography } from "@material-tailwind/react";
import NcInputNumberOne from "components/NcInputNumber/NcInputNumberOne";
import { LocationFormProps } from "data/reduxInterfaces";
import { useAppDispatch, useAppSelector } from "hooks/hooks";
import { FC, Fragment, HTMLAttributes, useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { fetchEquipments } from "redux/features/Admin/equipments/equipmentSlice";
import { RootState } from "redux/store";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import { z } from "zod";
export interface PageAddListing4Props {}

interface Equipment {
  id: number;
  designation: string;
}

interface ExtraEquipment {
  extra: string;
  price: number;
}

const formSchema = z.object({
  equipment: z.array(z.string()).optional().default([]),
  extraEquipment: z
    .array(
      z.object({
        extra: z.string(),
        price: z.number().optional(),
        quantity: z.number(),
      })
    )
    .optional()
    .default([]),
});

const LocationEquipment: FC<LocationFormProps & HTMLAttributes<HTMLDivElement>> = ({
  className,
  isLoading,
  handleForm,
  errorLocationForm,
  FormData,
}) => {
  const [selectedEquipment, setSelectedEquipment] = useState<number[]>([]);
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
    watch,
    trigger,
  } = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {},
    mode: "onSubmit",
  });

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const equipments: Equipment[] = useAppSelector((state) => state.featureEquipment.equipments);

  const handleSelect = (equipmentId: number, isChecked: boolean) => {
    if (isChecked) {
      setSelectedEquipment((prevSelectedEquipment) => [...prevSelectedEquipment, equipmentId]);
    } else {
      setSelectedEquipment((prevSelectedEquipment) =>
        prevSelectedEquipment.filter((selectedEvent) => selectedEvent !== equipmentId)
      );
    }

    setValue("equipment", selectedEquipment.map(String));
  };
  const [dataLoading, setDataLoading] = useState(true);

  useEffect(() => {
    dispatch(fetchEquipments()).then(() => setDataLoading(false));
  }, []);

  const onSubmit: SubmitHandler<z.infer<typeof formSchema>> = (data) => {
    FormData(data);
  };

  useEffect(() => {
    if (handleForm.type === "chekLocationFormFour") {
      handleSubmit(onSubmit)();
    }
  }, [handleForm]);

  const extras: { extra: string; price: number }[] = useSelector(
    (state: RootState) => state.featureLocation.extraEquipments
  );
  const [newextra, setNewextra] = useState<string>("");
  const [newextraPrice, setNewextraPrice] = useState<any>();
  const [newExtraQuantity, setNewExtraQuantity] = useState<any>("");

  const handleAddextra = () => {
    const price = newextraPrice !== "" && newextraPrice !== undefined ? newextraPrice : 0;
    if (newextra.trim() !== "") {
      const extraValues = getValues("extraEquipment") || [];
      setValue("extraEquipment", [
        ...extraValues,
        { extra: newextra, price: price || 0, quantity: newExtraQuantity || 1 },
      ]);
      setNewextra("");
      setNewextraPrice("");
      setNewExtraQuantity(1);
    }
  };
  const handleRemoveTag = (index: number) => {
    const newExtra = [...(getValues("extraEquipment") || [])];
    newExtra.splice(index, 1);
    setValue("extraEquipment", newExtra);
    trigger("extraEquipment");
  };

  return (
    <Fragment>
      <form className="w-full space-y-8" onSubmit={handleSubmit(onSubmit)}>
        {/* Section Liste des équipements */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 border border-gray-200 dark:border-gray-700 shadow-sm">
          <div className="flex items-center space-x-3 mb-6">
            <div className="w-10 h-10 bg-blue-100 dark:bg-blue-900/30 rounded-xl flex items-center justify-center">
              <span className="text-xl">⚡</span>
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white">Liste des équipements</h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">Sélectionnez les équipements disponibles</p>
            </div>
          </div>

          {dataLoading ? (
            <div className="flex items-center justify-center py-16">
              <div className="text-center">
                <Spinner color="blue" className="w-12 h-12 mx-auto mb-4" />
                <p className="text-gray-600 dark:text-gray-400">Chargement des équipements...</p>
              </div>
            </div>
          ) : (
            <div
              className={`grid gap-3 ${equipments.length > 10 ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3" : "grid-cols-1 sm:grid-cols-2"}`}
            >
              {equipments?.map((equipment) => (
                <Checkbox
                  key={equipment.id}
                  label={
                    <Typography className="text-gray-900 dark:text-white font-medium">
                      {equipment.designation}
                    </Typography>
                  }
                  name={String(equipment.id)}
                  onChange={(e) => handleSelect(equipment.id, e.target.checked)}
                />
              ))}
            </div>
          )}
        </div>

        {/* Section Équipements supplémentaires */}
        <div className="bg-white dark:bg-gray-800 rounded-2xl p-8 border border-gray-200 dark:border-gray-700 shadow-sm">
          <div className="flex items-center space-x-3 mb-6">
            <div className="w-10 h-10 bg-green-100 dark:bg-green-900/30 rounded-xl flex items-center justify-center">
              <span className="text-xl">➕</span>
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-900 dark:text-white">Équipements supplémentaires</h3>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Ajoutez des équipements payants personnalisés
              </p>
            </div>
          </div>

          {/* Liste des équipements supplémentaires ajoutés */}
          {((getValues("extraEquipment") as any[]) || []).length > 0 && (
            <div className="mb-6 space-y-3">
              {((getValues("extraEquipment") as any[]) || []).map((extraValues: any, index: any) => (
                <div
                  key={index}
                  className="bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-700 dark:to-gray-600 rounded-xl p-4 flex items-center justify-between"
                >
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-blue-100 dark:bg-blue-900/30 rounded-lg flex items-center justify-center">
                      <span className="text-sm font-bold text-blue-600 dark:text-blue-400">
                        {extraValues.quantity}
                      </span>
                    </div>
                    <div>
                      <p className="font-semibold text-gray-900 dark:text-white">{extraValues.extra}</p>
                      <p className="text-sm text-gray-600 dark:text-gray-400">
                        {extraValues.price !== 0 ? `Prix unitaire: ${extraValues.price} €` : "Gratuit"}
                      </p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => handleRemoveTag(index)}
                    className="w-8 h-8 bg-red-100 hover:bg-red-200 dark:bg-red-900/30 dark:hover:bg-red-900/50 rounded-lg flex items-center justify-center transition-colors"
                  >
                    <span className="text-red-600 dark:text-red-400">✕</span>
                  </button>
                </div>
              ))}
            </div>
          )}

          {/* Formulaire d'ajout */}
          <div className="bg-gray-50 dark:bg-gray-700/30 rounded-xl p-6">
            <h4 className="font-semibold text-gray-900 dark:text-white mb-4">Ajouter un nouvel équipement</h4>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Nom de l'équipement
                </label>
                <Input
                  placeholder="Ex: Système son professionnel..."
                  value={newextra}
                  onChange={(e) => setNewextra(e.target.value)}
                  className="rounded-xl border-gray-300 dark:border-gray-600"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                  Prix unitaire (€)
                </label>
                <Input
                  placeholder="25"
                  value={newextraPrice}
                  type="number"
                  onChange={(e) => {
                    const price = e.target.value.trim() !== "" ? Number(e.target.value) : 0;
                    setNewextraPrice(price);
                  }}
                  className="rounded-xl border-gray-300 dark:border-gray-600"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Quantité</label>
                <div className="flex space-x-2 items-end">
                  <NcInputNumberOne
                    defaultValue={newExtraQuantity}
                    onChange={(value) => setNewExtraQuantity(value)}
                    className="flex-1"
                  />
                  <ButtonPrimary
                    className="px-4 py-2 rounded-xl bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold shadow-lg hover:shadow-xl transition-all"
                    onClick={handleAddextra}
                    type="button"
                  >
                    <span className="text-lg">+</span>
                  </ButtonPrimary>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </Fragment>
  );
};

export default LocationEquipment;
